// extracted by mini-css-extract-plugin
export var bottombar = "PanelWrapper-module--bottombar--8e2a7";
export var container = "PanelWrapper-module--container--c02eb";
export var content = "PanelWrapper-module--content--421d6";
export var topbar = "PanelWrapper-module--topbar--edf58";
export var wrapper = "PanelWrapper-module--wrapper--671a9";